import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';
import OurTeamModel from './our-team.model.js';
import OurTeamInfoModel from './our-team-info.model.js';

class OurTeamService {
	getEmployees(lang) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/collections/get/Employees?lang=${lang}`,
			)
			.then(({ data }) => data.entries.map(entry => new OurTeamModel(entry)))
			.catch(logError);
	}

	getPageData(lang) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/ourTeam?lang=${lang}`,
			)
			.then(({ data }) => new OurTeamInfoModel(data))
			.catch(logError);
	}
}
export default new OurTeamService();
